module.exports = __webpack_public_path__ + "img/panda3.13c6504e.png";